module.exports = __webpack_public_path__ + "img/issuing-sample-process-2.63764bb9.png";